export interface Admin {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  isCaseManager?: boolean;
  status?: number;
  roleName?: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  role?: {
    id: string;
    name: string;
    description?: string;
    isActive?: boolean;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string;
    permissionConfigs?: PermissionConfig[];
  };
}

export interface PermissionConfig {
  id: string;
  configName: string;
  configKey: string;
  configType: number;
  index: number;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
}

export interface WhiteboardItem {
  id: string;
  message: string;
  index: number;
  admin: Admin;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  // For UI display purposes
  addedBy?: string;
  date?: string;
}

export interface WhiteboardState {
  items: WhiteboardItem[];
  loading: boolean;
  error: string | null;
  totalCount: number;
  currentPage: number;
  pageSize: number;
  isModalOpen: boolean;
  currentItem: WhiteboardItem | null;
  isEditing: boolean;
}

export interface WhiteboardResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data: WhiteboardItem[];
  counts: number;
  limit: number;
  offset: number;
}

export interface WhiteboardItemResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data: WhiteboardItem;
}

export interface WhiteboardOrderUpdate {
  id: string;
  index: number;
}

export enum WhiteboardActionTypes {
  FETCH_WHITEBOARD_ITEMS = "whiteboard/fetchItems",
  ADD_WHITEBOARD_ITEM = "whiteboard/addItem",
  UPDATE_WHITEBOARD_ITEM = "whiteboard/updateItem",
  DELETE_WHITEBOARD_ITEM = "whiteboard/deleteItem",
  MOVE_WHITEBOARD_ITEM_UP = "whiteboard/moveItemUp",
  MOVE_WHITEBOARD_ITEM_DOWN = "whiteboard/moveItemDown",
}
